import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminContacts } from '../services/getAdminContacts.service';

// The query comes from the caller rather than from state: it lives in the
// recipients field's own input and is never worth putting in the store.
export const searchAdminContacts = createAsyncThunk(
  'adminContacts/searchAdminContacts',
  async (query, { rejectWithValue }) => {
    try {
      return await getAdminContacts(query);
    } catch (error) {
      return rejectWithValue({
        status: error?.response?.status,
        message: error?.message,
      });
    }
  }
);
